export const PRESS_MENTIONS_LINKS = [
  {
    title: "NBC News",
    url: "http://www.nbcnews.com/nightly-news/black-friday-shopping-four-key-tips-you-hit-stores-n257436"
  },
  {
    title: "ABC News",
    url: "http://abcnews.go.com/blogs/business/2014/11/stick-to-a-holiday-budget-with-these-savings-secrets/"
  },
  {
    title: "Today Show",
    url: "http://www.today.com/home/swipe-away-holiday-stress-these-5-free-shopping-apps-1D80297442"
  },
  {
    title: "USA Today",
    url: "http://www.usatoday.com/story/tech/columnist/saltzman/2014/12/25/top-apps-of-2014/20591803/"
  },
  {
    title: "Time Magazine",
    url: "http://time.com/money/3647512/sell-trade-gift-cards/"
  }
];
